import { SVGProps, Ref, forwardRef } from 'react';

export const OkBrandAltSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                d="M8.012 7.948c.963 0 1.83-.386 2.46-1.016a3.47 3.47 0 0 0 1.014-2.458c0-.963-.385-1.829-1.015-2.459A3.46 3.46 0 0 0 8.012 1c-.962 0-1.828.385-2.458 1.015a3.46 3.46 0 0 0-1.015 2.459c0 .962.385 1.829 1.015 2.459a3.5 3.5 0 0 0 2.458 1.015m-1.11-4.594a1.57 1.57 0 0 1 1.11-.464c.438 0 .832.175 1.112.464.288.289.463.682.463 1.111s-.175.831-.463 1.111a1.57 1.57 0 0 1-1.112.464c-.437 0-.83-.175-1.11-.464a1.57 1.57 0 0 1-.465-1.111c0-.429.175-.822.464-1.111"
                fill="white"
            />
            <path
                d="M12.685 9.348 11.66 7.956c-.061-.079-.166-.087-.245-.026-.962.822-2.144 1.348-3.412 1.348-1.27 0-2.45-.534-3.413-1.348a.17.17 0 0 0-.245.026L3.331 9.347a.16.16 0 0 0 .026.22 7.16 7.16 0 0 0 2.897 1.408L4.1 14.764A.166.166 0 0 0 4.25 15h2.109a.16.16 0 0 0 .148-.096l1.505-3.36 1.505 3.36a.16.16 0 0 0 .15.096h2.108c.122 0 .201-.131.14-.236l-2.153-3.789a7.1 7.1 0 0 0 2.888-1.409c.07-.052.079-.149.035-.219"
                fill="white"
            />
        </g>
    </svg>
));
OkBrandAltSize16Glyph.displayName = 'OkBrandAltSize16Glyph';
